
import { api } from 'src/plugins/axios'

export default {
  loadInitial,
  fetchNew,
  fetchOrderNotifications,
}

async function loadInitial ({ state, commit }) {
  try{
    let { data } = await api.get('notifications/loadInitial')
    let notifications = data.payload.rows
    if(notifications.length > 0){
      state.notifications = notifications
    }
  }
  catch(err){
    
  }
}

async function fetchNew ({ state, commit }) {
  return await api.get('notifications/fetchNew')  
}


async function fetchOrderNotifications() {
  const { data } = await api.get('orders/fetchOrderNotifications')
  return data
}